// import React from 'react';
// import { Card, Container, Row, Col, Button } from 'react-bootstrap';
// import { FaMobileAlt, FaLaptopCode, FaRobot, FaBrain, FaDatabase, FaCloud, FaEthereum, FaAtom, FaGlobe, FaMountain } from 'react-icons/fa';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../styles/projects.css'; // Add a CSS file for custom styles

// const projects = [
//   {
//     title: "UI/UX Design Projects",
//     icon: <FaLaptopCode size={40} className="text-primary mb-3" />,
//     description: "  Designed intuitive user interfaces with a focus on user experience for web and mobile applications.",
//     link: "/projects/ux-design"
//   },
//   {
//     title: "Web Applications",
//     icon: <FaGlobe size={40} className="text-success mb-3" />,
//     description: "Developed responsive full-stack web applications with React, Node.js, and MongoDB.",
//     link: "/projects/web-applications"
//   },
//   {
//     title: "Mobile App Development",
//     icon: <FaMobileAlt size={40} className="text-info mb-3" />,
//     description: "Created cross-platform mobile apps using Flutter.",
//     link: "/projects/mobile-app"
//   },
//   {
//     title: "AI & ML Projects",
//     icon: <FaRobot size={40} className="text-warning mb-3" />,
//     description: "Implemented AI algorithms and machine learning models for predictive analytics.",
//     link: "/projects/ai-ml"
//   },
//   {
//     title: "Big Data Engineering",
//     icon: <FaDatabase size={40} className="text-danger mb-3" />,
//     description: "Built data pipelines and handled large datasets with Hadoop and Spark.",
//     link: "/projects/big-data"
//   },
//   {
//     title: "Data Science Projects",
//     icon: <FaBrain size={40} className="text-secondary mb-3" />,
//     description: "Performed data analysis and visualization for data-driven decisions.",
//     link: "/projects/data-science"
//   },
//   {
//     title: "Blockchain Projects",
//     icon: <FaEthereum size={40} className="text-primary mb-3" />,
//     description: "Developed decentralized applications using Ethereum and smart contracts.",
//     link: "/projects/blockchain"
//   },
//   {
//     title: "Quantum Computing",
//     icon: <FaAtom size={40} className="text-dark mb-3" />,
//     description: "Solved complex problems with quantum algorithms and quantum computing.",
//     link: "/projects/quantum-computing"
//   },
//   {
//     title: "Geology Project",
//     icon: <FaMountain size={40} className="text-danger mb-3" />,
//     description: "Researched geophysical exploration methods for energy resources.",
//     link: "/projects/geology"
//   },
//   {
//     title: "Exploration Geophysics",
//     icon: <FaGlobe size={40} className="text-warning mb-3" />,
//     description: "Analyzed geological data for resource exploration using geophysical techniques.",
//     link: "/projects/exploration-geophysics"
//   },
//   {
//     title: "Cloud Application Development",
//     icon: <FaCloud size={40} className="text-info mb-3" />,
//     description: "Developed scalable cloud-native applications with AWS and Azure.",
//     link: "/projects/cloud-development"
//   },
// ];

// const Projects = () => {
//   return (
//     <section className="projects-section py-5 bg-light" id="projects">
//       <Container>
//         <h2 className="text-center text-black fw-bold mb-4">Projects</h2>
//         <hr className="mb-4" />
//         <p className="text-center mb-4">Here are some of my key projects spanning UI/UX design, mobile apps, AI, blockchain, and quantum computing. Click to explore more details.</p>
//         <Row>
//           {projects.map((project, index) => (
//             <Col md={6} lg={4} key={index} className="mb-4">
//               <Card className="h-100 shadow-sm project-card">
//                 <Card.Body className="text-center">
//                   {project.icon}
//                   <Card.Title>{project.title}</Card.Title>
//                   <Card.Text className='fw-bold' >{project.description}</Card.Text>
//                   <Button 
//                     variant="primary" 
//                     href={project.link} 
//                     className="mt-3"
//                   >
//                     View Project
//                   </Button>
//                 </Card.Body>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default Projects;



import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/projects.css';



const projectsData = [
  {
    sectionTitle: "AI Projects",
    projects: [
      {
        title: "AI Project 1",
        description: "Implemented predictive models to enhance decision-making.",
        img: "path_to_image_1",
      },
      {
        title: "Data-Driven ML Model for Predicting Employee Attrition and Cluster-Based Retention Strategies  ",
        description: "Created a machine learning model to forecast employee turnover and employed clustering techniques alongside sentiment analysis to develop effective retention strategies.",
        img: "https://cdn.prod.website-files.com/60058af53d79fbd8e14841ea/65e09e368ec09be822cf5c0c_employee%20engagement%20retention.png",
      },
      {
        title: "AI Project 3",
        description: "Created a computer vision model for image recognition.",
        img: "path_to_image_3",
      },
    ],
  },
  {
    sectionTitle: "Mobile Apps",

    projects: [
      {
        title: "OlewinTech",
        description: "Mobile app for managing business operations and projects.",
        img: "path_to_image_olewintech",
      },
      // {
      //   title: "OlewinAI",
      //   description: "AI-powered app for insights and automation.",
      //   img:'https://via.placeholder.com/150',
      // },
      {
        title: "OlewinAcademy",
        description: "Educational app for online learning and courses.",
        img: "path_to_image_olewinacademy",
      },
      {
        title: "Geo&Geophy",
        description: "App for geophysical analysis and data visualization.",
        img: "path_to_image_geogeophy",
      },
      // {
      //   title: "Lamasala",
      //   description: "E-commerce app for homemade masalas and spices.",
      //   img: "path_to_image_lamasala",
      // },
    
    ],
  },
  {
    sectionTitle: "Full Stack Applications",
    projects: [
      {
        title: "Full Stack Project 1",
        description: "Inventory management system for retail businesses.",
        img: "path_to_image_7",
      },
      {
        title: "Full Stack Project 2",
        description: "CRM application for client relationship management.",
        img: "path_to_image_8",
      },
      {
        title: "Full Stack Project 3",
        description: "Analytics platform for data-driven decision making.",
        img: "path_to_image_9",
      },
    ],
  },
  {
    sectionTitle: "UI/UX Design",
    projects: [
      {
        title: "OlewinTechSolutions",
        description: "Corporate website design for OlewinTech Solutions.",
        img: "path_to_image_olewintechsolutions",
      },
      {
        title: "Geo&Geophy",
        description: "Website design for geophysical and geological services.",
        img: "path_to_image_geogeophy_web",
      },
      {
        title: "Lamasala",
        description: "E-commerce website for homemade masalas.",
        img: "path_to_image_lamasala_web",
      },
      {
        title: "Loanwala",
        description: "Website for loan services and financial solutions.",
        img: "path_to_image_loanwala_web",
      },
      {
        title: "Loanwala",
        description: "Blockchain managing loans and finances.",
        img: "path_to_image_loanwala",
      },
      {
        title: "Medicare Medicals",
        description: "Medical services and product ordering website.",
        img: "path_to_image_medicare_medicals",
      },
      {
        title: "OlewinAcademy",
        description: "Educational website for online courses and learning.",
        img: "path_to_image_olewinacademy_web",
      },
      {
        title: "Besta Sangam",
        description: "Community and cultural association website.",
        img: "path_to_image_besta_sangam",
      },
    ],
  },
];

const Projects = () => {
  return (
    <section className="my-3">
      <h2 className='fw-bold text-dark text-center' >Projects</h2> <hr/>
      <div className="container">
        {projectsData.map((section, sectionIndex) => (
          <div key={sectionIndex} className="my-3">
            {/* Section Title */}
            <div className="row">
              <div className="col-12 d-flex justify-content-start mb-4">
                <h2 className="fw-bold text-primary text-start">{section.sectionTitle}</h2> <hr/>
              </div>
            </div>
            {/* Project Cards */}
            <div className="row justify-content-center">
              {section.projects.map((project, projectIndex) => (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-2" key={projectIndex}>
                  <div className="card h-100 shadow-sm">
                    <img
                      src={project.img}
                      className="card-img-top"
                      alt={project.title}
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="card-body text-center">
                      <h5 className="card-title fw-bold">{project.title}</h5>
                      <p className="card-text">{project.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;